// extracted by mini-css-extract-plugin
export default {"root":"_3SEmb","button":"Mev0T"};